// extracted by mini-css-extract-plugin
module.exports = {"back":"MockupOrdering_back__14mFq","steps":"MockupOrdering_steps__27AuR","stepText":"MockupOrdering_stepText__30lSG","stepTextActive":"MockupOrdering_stepTextActive__29zBa"};